import React from "react";
import { Box, Typography, Paper, useMediaQuery, useTheme } from "@mui/material";

export default function ImpressumPage() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            px={isMobile? 0 : 4}
            py={4}
            sx={{ minHeight: "100%" }}
        >
            <Paper
                elevation={6}
                sx={{
                    minHeight: isMobile ? "20rem" : "25rem",
                    maxWidth: 700,
                    p: 4,
                    borderTopLeftRadius: 50,
                    backgroundColor: "#FFFFFE",
                }}
            >
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
                    Impressum
                </Typography>

                <Typography variant="body1" py={5}>
                    <strong>Adresse:</strong><br />
                    Arthur Friedrichs Start Up GmbH<br />
                    Barkhausenstraße 2<br />
                    27568 Bremerhaven<br />
		            <br />
  		            USt-ID:<br /> 
                    DE322840298 (gemäß §27a Umsatzsteuergesetz)<br />
  		             <br />
  		            Kontakt:<br />
		            m.thiel@afs-bhv.de<br />
		             j.beneken@afs-bhv.de
                </Typography>

                <Typography
                    variant="body1"
                    paragraph
                    sx={{ pb: 5 }}
                >
                    <strong>Komplementärin / General Partner:</strong><br />
                    Arthur Friedrichs Verwaltungs GmbH<br />
                    Barkhausenstraße 2, 27568 Bremerhaven<br />
                    Registergericht / Register Court: Bremen, HRB 41765 HB<br />
                    Sitz der Gesellschaft / Registered Office: Bremerhaven<br />
                    Geschäftsführer / General Director: Jens Beneken
                </Typography>
            </Paper>
        </Box>
    );
}
